import React from "react";

const ArrowLeft = () => {
  return (
    <div>
      <svg
        width="26"
        height="12"
        viewBox="0 0 26 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.573795 6.53033C0.280901 6.23744 0.280901 5.76256 0.573795 5.46967L5.34677 0.696699C5.63966 0.403806 6.11453 0.403806 6.40742 0.696699C6.70032 0.989593 6.70032 1.46447 6.40742 1.75736L2.16479 6L6.40742 10.2426C6.70032 10.5355 6.70032 11.0104 6.40742 11.3033C6.11453 11.5962 5.63966 11.5962 5.34677 11.3033L0.573795 6.53033ZM25.7767 6.75L1.10412 6.75V5.25L25.7767 5.25V6.75Z"
          fill="#FCFFFE"
        />
      </svg>
    </div>
  );
};

export default ArrowLeft;
